import { createMachine } from "xstate";

export const approveMachine = createMachine(
  {
    id: "PERMIT2",
    initial: "HAS_EXISTING_APPROVAL",
    states: {
      HAS_EXISTING_APPROVAL: {
        on: {
          ON_HAS_EXISTING_APPROVAL: {
            target: "IS_APPROVAL_SUFFICIENT",
            reenter: true,
          },
          ON_INSUFFICIENT_APPROVAL: {
            target: "APPROVE",
            reenter: true,
          },
        },
      },
      IS_APPROVAL_SUFFICIENT: {
        on: {
          ON_SUFFICIENT_APPROVAL: {
            target: "DONE",
            reenter: true,
          },
          ON_INSUFFICIENT_APPROVAL: {
            target: "IS_REVOKE_FIRST_TOKEN",
            reenter: true,
          },
        },
      },
      APPROVE: {
        initial: "PENDING_APPROVAL",
        states: {
          PENDING_APPROVAL: {
            on: {
              ON_APPROVAL_START: {
                target: "CONFIRM_IN_WALLET",
                reenter: true,
              },
            },
          },
          CONFIRM_IN_WALLET: {
            on: {
              ON_CONFIRM: {
                target: "WAITING_FOR_TX",
                reenter: true,
              },
              ON_APPROVAL_REJECT: {
                target: "RETRY_APPROVE",
                reenter: true,
              },
            },
          },
          WAITING_FOR_TX: {
            on: {
              ON_TX_RECIEPT: {
                target: "TX_CONFIRMED",
                reenter: true,
              },
              ON_TX_FAIL: {
                target: "RETRY_APPROVE",
                reenter: true,
              },
            },
          },
          RETRY_APPROVE: {
            on: {
              ON_RETRY: {
                target: "CONFIRM_IN_WALLET",
                reenter: true,
              },
            },
          },
          TX_CONFIRMED: {
            on: {
              ON_APPROVED: {
                target: "#PERMIT2.IS_REAPPROVED_AMOUNT_SUFFICIENT",
                reenter: true,
              },
            },
          },
        },
      },
      DONE: {
        type: "final",
      },
      IS_REVOKE_FIRST_TOKEN: {
        on: {
          ON_IS_REVOKE_FIRST: {
            target: "REVOKE",
            reenter: true,
          },
          ON_IS_NOT_REVOKE_FIRST: {
            target: "APPROVE",
            reenter: true,
          },
        },
      },
      REVOKE: {
        initial: "PENDING_REVOKE",
        states: {
          PENDING_REVOKE: {
            on: {
              ON_REVOKE_START: {
                target: "CONFIRM_IN_WALLET",
                reenter: true,
              },
            },
          },
          CONFIRM_IN_WALLET: {
            on: {
              ON_REVOKE_CONFIRM: {
                target: "WAITING_FOR_TX",
                reenter: true,
              },
              ON_REVOKE_REJECT: {
                target: "RETRY_REVOKE",
                reenter: true,
              },
            },
          },
          WAITING_FOR_TX: {
            on: {
              ON_TX_RECEIPT: {
                target: "REVOKE_TX_CONFRIMED",
                reenter: true,
              },
              ON_REVOKE_TX_FAIL: {
                target: "RETRY_REVOKE",
                reenter: true,
              },
            },
          },
          RETRY_REVOKE: {
            on: {
              ON_RETRY_REVOKE: {
                target: "CONFIRM_IN_WALLET",
                reenter: true,
              },
            },
          },
          REVOKE_TX_CONFRIMED: {
            on: {
              ON_REVOKED: {
                target: "#PERMIT2.APPROVE",
                reenter: true,
              },
            },
          },
        },
      },
      IS_REAPPROVED_AMOUNT_SUFFICIENT: {
        on: {
          ON_SUFFICIENT_AMOUNT: {
            target: "DONE",
            reenter: true,
          },
          ON_INSUFFICIENT_APPROVAL: {
            target: "CUSTOM_APPROVALS",
            reenter: true,
          },
        },
      },
      CUSTOM_APPROVALS: {
        on: {
          ON_RESTART: {
            target: "IS_REVOKE_FIRST_TOKEN",
            reenter: true,
          },
        },
      },
    },
    types: {
      events: {} as
        | { type: "" }
        | { type: "ON_RETRY" }
        | { type: "ON_CONFIRM" }
        | { type: "ON_RESTART" }
        | { type: "ON_REVOKED" }
        | { type: "ON_TX_FAIL" }
        | { type: "ON_APPROVED" }
        | { type: "ON_TX_RECEIPT" }
        | { type: "ON_TX_RECIEPT" }
        | { type: "ON_RETRY_REVOKE" }
        | { type: "ON_REVOKE_START" }
        | { type: "ON_REVOKE_REJECT" }
        | { type: "ON_APPROVAL_START" }
        | { type: "ON_REVOKE_CONFIRM" }
        | { type: "ON_REVOKE_TX_FAIL" }
        | { type: "ON_APPROVAL_REJECT" }
        | { type: "ON_IS_REVOKE_FIRST" }
        | { type: "ON_SUFFICIENT_AMOUNT" }
        | { type: "ON_IS_NOT_REVOKE_FIRST" }
        | { type: "ON_SUFFICIENT_APPROVAL" }
        | { type: "ON_HAS_EXISTING_APPROVAL" }
        | { type: "ON_INSUFFICIENT_APPROVAL" },
    },
  },
  {
    actions: {},
    actors: {},
    guards: {},
    delays: {},
  }
);
